import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t border-border bg-surface mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-lg font-bold text-primary mb-3">LyricsHub</h3>
            <p className="text-sm text-text-muted leading-relaxed">
              Tu plataforma de letras de canciones con modo karaoke, traducciones y más.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-3">Navegación</h4>
            <ul className="space-y-2">
              {[
                { to: '/', label: 'Inicio' },
                { to: '/search', label: 'Explorar' },
                { to: '/genres', label: 'Géneros' },
                { to: '/charts/weekly', label: 'Charts' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-text-secondary hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-3">Comunidad</h4>
            <ul className="space-y-2">
              {[
                { to: '/register', label: 'Crear cuenta' },
                { to: '/login', label: 'Iniciar sesión' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-text-secondary hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-3">Legal</h4>
            <ul className="space-y-2">
              {[
                { to: '/terms', label: 'Términos de servicio' },
                { to: '/privacy', label: 'Privacidad' },
                { to: '/dmca', label: 'DMCA' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-text-secondary hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-text-muted">
            &copy; {new Date().getFullYear()} LyricsHub. Desarrollado por Decatron.
          </p>
          <p className="text-xs text-text-muted text-center">
            Las letras son propiedad de sus respectivos autores y discográficas.
          </p>
        </div>
      </div>
    </footer>
  );
}
